
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcTextInputField as ObcTextInputFieldElement} from '@oicl/openbridge-webcomponents/dist/components/text-input-field/text-input-field.js';
 
 
 

 
 export const ObcTextInputField = createComponent({
   react: React,
   tagName: 'obc-text-input-field',
   elementClass: ObcTextInputFieldElement,
   events: {
     
     onInput: 'input' as EventName<CustomEvent<unknown>>,
     onChange: 'change' as EventName<CustomEvent<unknown>>,
     onClear: 'clear' as EventName<CustomEvent<unknown>>,
     onBlur: 'blur' as EventName<CustomEvent<unknown>>,
   }
  });
 
 